export default __webpack_public_path__ + "static/media/buble_img.5cafe863.svg";